import React, { useContext, useEffect, useState } from 'react';
import './Internship.css';
import { FaLaptop, FaCertificate, FaUsers, FaHandsHelping } from 'react-icons/fa';
import { RiLiveFill } from 'react-icons/ri';
import { GiSkills } from 'react-icons/gi';
import dimg from './digitalpic.png';
import GuestNav from '../Navbars/GuestNav';
import Footer from "../Footer";
import { UserContext } from '../UserContext';
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";

const Internship = () => {
  const { isGuest, setUserRole, setUserInfo } = useContext(UserContext);
  const [userInfo, setLocalUserInfo] = useState(null);
  const [activeAccordion, setActiveAccordion] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_LOCAL_SERVER_API}`, {
          credentials: 'include',
        });
        const userData = await response.json();
        console.log("userinfo:", userData);
        setLocalUserInfo(userData);
        setUserInfo(userData);

        if (userData?.usertype) {
          const uType = userData?.usertype;
          setUserRole(uType);
        }

        const uname = userData?.username;
        const avatar = userData?.avatar;
        console.log("Uname: ", uname);
        console.log("Avatar: ", avatar);
      } catch (err) {
        console.log("Error in useEffect:", err);
      }
    };
    fetchData();
  }, [setUserInfo, setUserRole]);

  const determineUserRole = (usertype) => {
    console.log("In home.js:", usertype);
    if (usertype === 'Student') return "Student";
    else if (usertype === 'Teacher') return "Teacher";
    else if (usertype === 'Admin') return "Admin";
    else return "guest";
  };

  const onLogin = (usertype) => {
    const userRole = determineUserRole(usertype);
    console.log("Calling setUserRole.");
    setUserRole(userRole);
  };

  function onLogout() {
    console.log("inside Onlogout.");
    fetch(`${process.env.REACT_APP_LOCAL_SERVER_API}/logout`, {
      credentials: 'include',
      method: 'POST',
    });
    setUserInfo(null);
    setUserRole('guest');
    navigate("/");
  }

  const username = userInfo?.username;

  return (
    <>
      {!username && isGuest && <GuestNav />}
      <div className="internship-container">
        {/* Hero Section */}
        <div className="hero-section">
          <div className="hero-content">
            <h1>Learn & Intern: <span>Teen Program</span></h1>
            <p className="tagline">Unlock your digital creativity this summer!</p>
            <div className="focus-areas">
              <div className="focus-bubble">Social Media Marketing</div>
              <div className="focus-bubble">Content Writing</div>
              <div className="focus-bubble">Graphic Designing</div>
            </div>
            {/* <p class="registration-status">The registration is currently closed</p> */}
            <Link to="/InternshipReg" className="cta-button">
                                   Apply Now
                                  </Link>
          </div>
          <div className="hero-image">
            <img src={dimg} alt="image" />
          </div>
        </div>

      {/* Program Highlights */}
<div className="highlights-section">
  <div className="program-intro">
    <p>
      Are you looking for an opportunity that will boost your university applications and will be a valuable addition to your resume. Our learn & intern program is especially designed for O/A Level and Matric/FSc students. It is a perfect opportunity for you to gain hands-on experience on the most demanding skills of graphic designing, content writing, and digital marketing. Whether you're aiming for university admission or exploring career options, this experience will be an ideal addition to your resume and cover letters. The perfect opportunity to learn from home and also get hands-on experience in real life projects.
    </p>
  </div>

        {/* Program Highlights */}
        <div className="highlights-section">
          <h2>🌟 Why Join This Learn & Intern: Teen Program by Polymath-Kids?</h2>
          <div className="highlights-grid">
            <div className="highlight-card">
              <RiLiveFill className="highlight-icon" />
              <h3>Live Interactive Lessons</h3>
              <p>Engage with expert mentors in real-time sessions</p>
            </div>
            <div className="highlight-card">
              <GiSkills className="highlight-icon" />
              <h3>Hands-on Projects</h3>
              <p>Learn by doing with real-world examples</p>
            </div>
            <div className="highlight-card">
              <FaLaptop className="highlight-icon" />
              <h3>Independent Learning</h3>
              <p>Build confidence with guided tasks</p>
            </div>
            <div className="highlight-card">
              <FaHandsHelping className="highlight-icon" />
              <h3>1-on-1 Mentor Support</h3>
              <p>Personalized guidance for your journey</p>
            </div>
            <div className="highlight-card">
              <FaCertificate className="highlight-icon" />
              <h3>Internship Certificate</h3>
              <p>Earn recognition for your new skills</p>
            </div>
          </div>
        </div>
</div>
        {/* Program Details */}
        <div className="details-section">
          <div className="details-card age-duration">
            <h3>Perfect For Ages</h3>
            <p className="big-text">14-18 Years</p>
            <h3>Program Duration</h3>
            <p className="big-text">4-6 Weeks</p>
          </div>
          <div className="details-card format">
            <h3>Learning Format</h3>
            <ul>
              <li>Live Online Classes</li>
              <li>Guided Independent Learning</li>
              <li>Interactive Projects</li>
              <li>Mentor Feedback Sessions</li>
            </ul>
          </div>
        </div>

        {/* Testimonials */}
        <div className="testimonials-section">
          <h2>What Our Young Creators Say</h2>
          <div className="testimonials-container">
            <div className="testimonial-card">
              <div className="testimonial-content">
                "I had the opportunity to intern with Polymath Kids for two months, where I gained valuable experience . This internship provided me with a practical understanding of how creative and strategic elements come together to build an engaging online presence for a brand."
              </div>
              <div className="testimonial-author">- Sophia Khan, 16 years old</div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-content">
                "I gained significant skills by taking part in this internship. Not only did it give me something productive to work on during the summer break but also boosted my knack for writing and graphic designing. It's a great opportunity for discovering and enhancing your talents."
              </div>
              <div className="testimonial-author">- Falah Hamad Sahaf, 15</div>
            </div>
          </div>
        </div>

        {/* FAQ Accordion */}
<div className="faq-section">
  <h2>Frequently Asked Questions</h2>
  <div className="accordion">
    <div className="accordion-item active">
      <button className="accordion-question">
        Can this internship program help kids in future?
      </button>
      <div className="accordion-answer">
        Yes, they will get hands-on experience and they can use the skills in practical and professional life.
      </div>
    </div>
    
    <div className="accordion-item">
      <button className="accordion-question">
        What domains are covered in this online internship?
      </button>
      <div className="accordion-answer">
        There are various domains including content writing, social media marketing and graphic designing in Canva.
      </div>
    </div>
    
    <div className="accordion-item">
      <button className="accordion-question">
        Is there any registration fee?
      </button>
      <div className="accordion-answer">
        Yes, there is only Rs 1000 registration fee.
      </div>
    </div>
    
    <div className="accordion-item">
      <button className="accordion-question">
        Will kids do real life projects?
      </button>
      <div className="accordion-answer">
        Yes, they will do real life projects in designing, content writing and marketing. The best work will also be published on our website and social media platforms.
      </div>
    </div>
    
    <div className="accordion-item">
      <button className="accordion-question">
        What is the learning format?
      </button>
      <div className="accordion-answer">
        There will be one weekly online class, and the rest it will be independent learning where kids will work on projects.
      </div>
    </div>
    
    <div className="accordion-item">
      <button className="accordion-question">
        What is the age limit?
      </button>
      <div className="accordion-answer">
        Kids aged between 14 to 18 can apply for this internship.
      </div>
    </div>
    
    <div className="accordion-item">
      <button className="accordion-question">
        Will there be any certificate?
      </button>
      <div className="accordion-answer">
        Yes, we will offer a full certificate that will help in future careers for the kids.
      </div>
    </div>
    
    <div className="accordion-item">
      <button className="accordion-question">
        Can kids join from anywhere?
      </button>
      <div className="accordion-answer">
        Yes, we cater to kids around the world. The reason we offer this online is to cater to vast audience.
      </div>
    </div>
    
    <div className="accordion-item active">
      <button className="accordion-question">
        What tech do I need to participate?
      </button>
      <div className="accordion-answer">
        Just a computer/tablet with internet access! We'll guide you through any software installations.
      </div>
    </div>
  </div>
</div>
        {/* Final CTA */}
        <div className="final-cta">
          <h2>Ready to Start Your Digital Journey?</h2>
          <p>Limited spots available for our next cohort</p>
          <Link to="/InternshipReg" className="cta-button">
                                   Apply Now
                                  </Link>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Internship;